module.exports = __webpack_public_path__ + "videos/video-aleo-graphism-mobile.f70fcfd.mp4";